import React, { Component, Fragment } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import backgroundimage from "../../style/images/game/MAIN/playgbg.png";
import online from "../../style/images/game/MAIN/play-online-btn.png";
import offline from "../../style/images/game/MAIN/play-offline-btn.png";
import snake from "../../style/images/home/test image.png";
import "./singleTournament.css";
import TournamentList from "./tournamentlist";
import LeaderBoard from "./LeaderBoard";
import Rules from "./rules";

import { Tabs, List, Row, Col, Card, Button } from "antd";

import "../../../node_modules/video-react/dist/video-react.css";

import { Player } from "video-react";

export default class SingleTournament extends Component {
  render() {
    return (
      <Fragment>
        <Header {...this.props} />
        <Card
          className="Card"
          bodyStyle={{ backgroundColor: "transparent" }}
        >
          <div class="row">
            <div class="col-md-6">
              <Player
                playsInline
                // poster={backgroundimage}
                src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
              />
              <div class="tlr">
                <div className="row">
                  <div className="col-xs-4">
                    <span class="tour">TOURNAMENTS</span>
                  </div>
                  <div className="col-xs-4">
                    <span class="lead">LEADERBORADS</span>
                  </div>
                  <div className="col-xs-4">
                    <span class="rule">RULES</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-md-6 " style={{ position: "relative" }}>
              <img className="snake" src={snake} />
              <div className="gametext">
                <h1 className="MainText">Snake</h1>
                <p className="MainTextP">
                  <i>
                    Join 100's <br /> of players
                  </i>
                </p>
                <a href="#">
                  <Button
                    style={{ color: "transparent", display: "contents" }}
                    type="image"
                  >
                    <img src={online} className="buttonimage" />
                  </Button>
                </a>
                <br /> <br />
                <p className="MainTextP">
                  <i>
                    {" "}
                    or try the game <br />
                    with Practice Mode
                  </i>
                </p>
                <a href="#">
                  <Button
                    style={{ color: "transparent", display: "contents" }}
                    type="image"
                  >
                    <img src={offline} className="buttonimage" />
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </Card>
        <TournamentList />
        <LeaderBoard />
        <Rules />
        <Footer />
      </Fragment>
    );
  }
}
